<!--
  ~
  ~ Copyright (c) 2020 TenderHub LLC. All rights reserved
  ~
  ~ This software is the confidential and proprietary information of
  ~ TenderHub LLC ("Confidential Information"). You shall not disclose
  ~ such Confidential Information.
  ~
  -->
<div [class]="deviceInfo.isDesktop ? 'desktop-layout--adaptive' : 'mobile-layout--adaptive'">
	<router-outlet></router-outlet>
</div>
